import { Directive } from '@angular/core';
import {
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

export class JariValidators {
  static validStringRegex = /^[^*|\":<>[\]{}`\\()';@&$]+$/;
  static emailPattern: string =
    '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';
    static saudiNationalIdPattern =  /^(1|2)[0-9]{9}$/;
    static validPhoneNumberRegex =
    /^(\+|00|0)(9665|9661|9669|5)(5|0|3|6|4|9|1|8|7|2)([0-9]{7})$/;
  static validPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[a-zA-Z\d@$!%*?&]{8,16}$/;
  static englishArabicNoNumbersPattern = /^[\p{L}A-Za-z\s]+$/u;
  static validStringForEmailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  static saPattern = /^SA[0-9]{22}$/;
  static validSaudiPhoneNumberRegex =  /^5[0-9]{8}$/;
  static arabicOnlyRegex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\s\-'\.]+$/;
  static englishOnlyRegex = /^[A-Za-z\s\-'\.]+$/;
  static arabicWithNumbersAndSpecialsRegex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF0-9\u0660-\u0669\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
  static englishWithNumbersAndSpecialsRegex = /^[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
static englishArabicNumbersSpecialsRegex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
  static newIbanPattern = /^SA[A-Z0-9]{22}$/;

  static isValidPhoto(file: File): boolean {
    const allowedExtensions = ['image/png', 'image/jpg', 'image/jpeg'];
    return allowedExtensions.includes(file.type);
  }
  static sanitizeIbanInput(value: string | null | undefined): string {
    if (!value) return '';
    return value
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 24);
  }
  static matchingAccountIbanValidator: ValidatorFn = (
    group: AbstractControl
  ): ValidationErrors | null => {
    const iban = group.get('iban')?.value;
    const bankAccountNumber = group.get('bankAccountNumber')?.value;

    if (!iban.includes(bankAccountNumber)) {
      return { accountIbanMismatch: true };
    }

    return null;
  };
  static noSpecialCharactersValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const forbidden = /[!@#$%^&*(),.?":{}|<>]/.test(control.value);
    return forbidden ? { noSpecialCharacters: { value: control.value } } : null;
  };

  static noWhitespaceOnlyValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value.toString().trim() === '') {
      return { noWhitespaceOnly: true };
    }
    return null;
  };
}

@Directive({
  selector: '[appWhitespaceValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: WhitespaceValidatorDirective,
      multi: true,
    },
  ],
})
export class WhitespaceValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value || '';
    const isValid =!value||(value.trim&& value.trim().length > 0);
    return isValid ? null : { required: true };
  }
}
